/**
 * @component NewsDetailPage
 * @description 선택된 뉴스의 본문과 발행 정보를 상세 노출하는 콘텐츠 상세 페이지입니다.
 * @usage App 라우팅에서 `/news/:slug.html` 경로일 때 렌더링됩니다.
 */

import { useState, useEffect } from 'react';
import PageHero from '../../components/common/PageHero';

export default function NewsDetailPage({ slug, onNavigate }) {
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);

  // [기능] 백엔드 API에서 뉴스 목록을 가져와 slug에 해당하는 기사를 찾습니다.
  useEffect(() => {
    fetch('/api/news')
      .then((r) => r.json())
      .then((items) => {
        // [파생 상태] URL slug와 일치하는 기사를 찾고, 없으면 첫 기사를 기본값으로 사용합니다.
        const found = items.find((item) => item.slug === slug) ?? items[0] ?? null;
        setArticle(found);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [slug]);

  if (loading) {
    return (
      <section className="section">
        <div className="container">
          <div className="news-detail card-panel fade-in">
            <p>로딩 중...</p>
          </div>
        </div>
      </section>
    );
  }

  if (!article) {
    return (
      <>
        <PageHero title="News" trail={['News']} className="news-page-hero" />
        <section className="section">
          <div className="container">
            <article className="news-detail card-panel fade-in">
              <p>기사를 찾을 수 없습니다.</p>
              <button
                type="button"
                className="secondary-button"
                onClick={() => onNavigate('/news/index.html')}
              >
                목록으로
              </button>
            </article>
          </div>
        </section>
      </>
    );
  }

  return (
    <>
      <PageHero title={article.title} trail={['News', article.title]} className="news-page-hero" />
      <section className="section">
        <div className="container">
          <article className="news-detail card-panel fade-in">
            <span>{article.category}</span>
            <h2>{article.title}</h2>
            <small>{article.date}</small>
            {(article.body ?? []).map((paragraph, i) => (
              <p key={i}>{paragraph}</p>
            ))}
            {/* [이벤트 처리]: 뉴스 목록 페이지로 돌아갑니다. */}
            <button
              type="button"
              className="secondary-button"
              onClick={() => onNavigate('/news/index.html')}
            >
              목록으로
            </button>
          </article>
        </div>
      </section>
    </>
  );
}
